// frontend/src/pages/SystemAdmin.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Page from "../ui/Page";
import { Button } from "../ui/UIComponents";

export default function SystemAdmin() {
  const nav = useNavigate();

  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch("/api/auth?action=me-user", { credentials: "include" });
        const j = await r.json().catch(() => ({}));
        const adminFlag = !!(j && (j.admin === true || j.is_admin === true || j.role === "admin"));
        setIsAdmin(adminFlag);
      } catch {
        setIsAdmin(false);
      } finally {
        setChecking(false);
      }
    })();
  }, []);

  function open(path) {
    if (!isAdmin) return;
    nav(path);
  }

  function backToSysAdminDept() {
    // Back to System Admin department tool list
    nav("/dept/sysadmin");
  }

  const tools = [
    {
      id: 1,
      vi: "New User",
      en: "Approve & Send OTP",
      descVi: "",
      descEn: "Approve requests and send/resend OTP",
      path: "/sysadmin/access",
    },
  ];

  return (
    <Page>
      <main className="container">
        <h1 className="menu-title">Tuiss Web Tools — Web Tools Admin</h1>
        <h2 style={{ marginTop: -8 }}>Setup / Configuration</h2>

        <div style={{ margin: "8px 0 16px" }}>
          <Button onClick={backToSysAdminDept}>← Trở về / Back</Button>
        </div>

        {checking && (
          <div className="box" style={{ marginTop: 12 }}>
            Đang kiểm tra quyền / Checking permissions…
          </div>
        )}

        {!checking && !isAdmin && (
          <div className="box" style={{ marginTop: 12 }}>
            <strong>403 — Forbidden.</strong> Bạn không có quyền truy cập trang này.
            <div style={{ marginTop: 8 }}>
              <a className="inline" href="/menu">← Back to Menu</a>
            </div>
          </div>
        )}

        {!checking && isAdmin && (
          <div className="menu-grid">
            {tools.map((t) => (
              <button
                key={t.id}
                className="menu-card"
                onClick={() => open(t.path)}
                title={`${t.vi} / ${t.en}`}
              >
                <span className="menu-id">{t.id}.</span>
                <span className="menu-text">
                  {t.vi} / {t.en}
                </span>
                <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                  {t.descVi} / {t.descEn}
                </div>
              </button>
            ))}
          </div>
        )}
      </main>
    </Page>
  );
}
